import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { ChangeStorymapAiLanguage as ChangeStorymapAiLanguageCommand } from '../../api/commands';
import { useStorymapStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeStorymapAiLanguage extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeStorymapAiLanguage';

    public constructor(public language: string) {
        super(ChangeStorymapAiLanguage.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeStorymapAiLanguage): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new ChangeStorymapAiLanguageCommand(state.id, action.language),
    });
};

const reducer = (state: StorymapState, action: ChangeStorymapAiLanguage): void => {
    state.aiData.language = action.language;
};

//@ts-ignore
registerMiddleware(ChangeStorymapAiLanguage.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeStorymapAiLanguage.ACTION_TYPE, reducer);
